import { PropsOf } from '@emotion/react';
import Konva from 'konva';
import React, { forwardRef } from 'react';
import { Transformer as KonvaTransformer } from 'react-konva';

const MIN_ITEM_DIM = 5;

export const Transformer = forwardRef<Konva.Transformer, PropsOf<typeof KonvaTransformer>>(({ resizeEnabled, ...restProps }, ref) => (
  <KonvaTransformer
    ref={ref}
    keepRatio={false}
    rotateEnabled={false}
    resizeEnabled={resizeEnabled}
    boundBoxFunc={(oldBoundBox, newBoundBox) => {
      if (newBoundBox.rotation < 0 || newBoundBox.width < MIN_ITEM_DIM || newBoundBox.height < MIN_ITEM_DIM) {
        return oldBoundBox;
      }

      return newBoundBox;
    }}
    {...restProps}
  />
)) as unknown as typeof KonvaTransformer;
